import * as logs from "./logs"

export const hunt = {
    ...logs
};


